import {initializeApp} from "firebase/app";
import {getMessaging ,onMessage} from "firebase/messaging";
import "firebase/messaging";
import Vue from '@/main';
import store from '@/store';
import Toast from '@/components/toast/Toast';

let messaging;

try {
  const firebaseApp = initializeApp(window.firebaseConfig); //config imported in index.html
  messaging = getMessaging(firebaseApp);

  onMessage((payload) => {
    const payloadUuid = payload.data.message;

    if (payloadUuid !== store.state.auth.entity.uuid || !store.state.auth.isAuthorized) {
      return;
    }

    Vue.$toast.info({
      component: Toast,
      props: {
        title: payload.data.title,
        body: payload.data.body,
        to: payload.data.url,
      }
    });
  })
} catch (e) {
  // eslint-disable-next-line no-console
  console.log(e);
}

export default messaging;
